var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:_vm.iconClass,attrs:{"size":_vm.size}},[_vm._v("insert_drive_file")])}
var staticRenderFns = []

export { render, staticRenderFns }